/* eslint-disable @typescript-eslint/no-explicit-any */
import TagManager from 'react-gtm-module';
import { getQueryParams } from '@creditasmx-utilities/helpers';

import { EnumStorage } from '../../storage.constants';

import {
  TrackingContextProps,
  TrackingEvent,
  TrackingPage,
} from './tagManager.types';

const queryParams = getQueryParams();
const companyId = queryParams.get('companyId') || '';

const sendTrackingEvent = (eventData: object): void => {
  const gtmId = process.env.REACT_APP_GTM_ID;
  const utm = JSON.parse(sessionStorage.getItem(EnumStorage.UTM) || '{}');

  const eventDataLayer = {
    ...eventData,
    utm,
  };

  if (gtmId) {
    TagManager.dataLayer({
      dataLayer: eventDataLayer,
    });
  }
};

const trackEvent = ({
  event,
  extraInfo,
}: {
  event: TrackingEvent;
  extraInfo?: any;
}): void => {
  sendTrackingEvent({
    ...event,
    ...extraInfo,
    companyId,
  });
};

const trackEventForm = ({
  event,
}: {
  event: TrackingEvent;
  input: {
    name: string;
  };
}): void => {
  sendTrackingEvent({
    ...event,
    companyId,
  });
};

const trackPageLoad = ({
  page,
  event,
}: {
  page: TrackingPage;
  event?: any;
}): void => {
  sendTrackingEvent({
    event: 'page_view',
    category: page.category,
    action: page.action,
    companyId,
    ...event,
  });
};

export const tracking: TrackingContextProps = {
  trackEvent,
  trackPageLoad,
  trackEventForm,
};
